export const POWERBI_EMBEDDED_TOKEN_REFRESH_INTERVAL = 15 * 60 * 1000;

export const SUBMODULE_NAME_CORE = 'core';
export const SUBMODULE_NAME_BOOKMARKS = 'bookmarks';

export const DEFAULT_ANALYTICS_ERROR_ALERT_ID = 'analytics';
